var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidderVipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00016,
    cy: 7.00016,
    r: 6.66667,
    fill: "#40629F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1793 4.21179C10.4305 3.94262 10.8524 3.92808 11.1216 4.1793C11.3907 4.43052 11.4053 4.85238 11.154 5.12155L6.48738 10.1215C6.24364 10.3827 5.83738 10.4053 5.56615 10.1728L3.23282 8.17284C2.95327 7.93323 2.92089 7.51236 3.16051 7.23281C3.40012 6.95326 3.82099 6.92088 4.10054 7.1605L5.94867 8.74461L10.1793 4.21179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidderVipIcon);
export default __webpack_public_path__ + "static/media/bidder-vip-icon.8ec758d7429807860853e28614d0f7b2.svg";
export { ForwardRef as ReactComponent };